import { useMemo } from "react";
import { DEFAULT_THEME_NAME } from "../../constants.js";
import { useStoredThemes, useStoredThemesApi } from "../../context/StoredThemes.js";
function useComputeThemes(onClose) {
  const { themes: storedThemes, activeThemeName } = useStoredThemes();
  const storedThemesApi = useStoredThemesApi();
  return useMemo(() => {
    return Object.entries(storedThemes).map(([name, theme]) => {
      const active = name === activeThemeName;
      const defaultTheme = name === DEFAULT_THEME_NAME;
      return {
        active,
        defaultTheme,
        name,
        onDelete: () => {
          if (defaultTheme) {
            throw new Error("Cannot delete default theme");
          }
          if (active) {
            storedThemesApi.loadTheme(DEFAULT_THEME_NAME);
          }
          storedThemesApi.removeTheme(name);
        },
        onLoad: () => {
          storedThemesApi.loadTheme(name);
          onClose();
        },
        theme
      };
    });
  }, [storedThemes, activeThemeName, storedThemesApi, onClose]);
}
export {
  useComputeThemes
};
//# sourceMappingURL=useComputeThemes.js.map
